"use client"
import React, { useContext } from "react"
import Grid from "@mui/material/Grid"
import {GLOBAL_PATHS} from "@/lib/globals"
import {Box, Paper, Stack, Typography, useMediaQuery, useTheme} from "@mui/material"

import FooterWrapper from "@/ui/layouts/FooterWrapper"
import { TranslationContext } from "@/configs/context"


export default function AboutWrapper ({  }) {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  const titleFontSize = matchMd ? "2.5rem" : "1.9rem"

  return (
    <React.Suspense fallback={<div />}>
      <Box
        sx={{
          p: 2,
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
        }}
      >
        <Grid
          container
          alignItems="flex-start"
          justifyContent="center"
          spacing={{ xs: 1, lg: 3 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 11, lg: 11, xl: 8 }}>
            <Paper
              elevation={0}
              sx={{
                mb: 2,
                width: "100%",
                textAlign: "left",
                height: matchMd ? "20rem" : "14rem",
                backgroundSize: "100% 100% !important",
                backgroundRepeat: "no-repeat !important",
                backgroundPosition: "center top !important",
                backgroundImage: `url(${GLOBAL_PATHS.COVERS}bg-2.jpg) !important`,
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                sx={{ p: 2, height: "100%" }}
                justifyContent="space-between"
              >
                <Box>
                  <Typography
                    variant="h1"
                    color="common.white"
                    fontSize={titleFontSize}
                    align={matchMd ? "left" : "center"}
                  >
                    Bienvenue sur Djotta
                  </Typography>
                  <Typography
                    gutterBottom
                    color="common.white"
                    variant={matchMd ? "h5" : "body1"}
                    align={matchMd ? "left" : "center"}
                  >
                    Des solutions innovantes pour transformer vos idées en réalité !
                  </Typography>
                </Box>
              </Stack>
            </Paper>
            <Paper
              elevation={0}
              sx={{ p: 3, textAlign: matchMd ? "left" : "center" }}
            >
              <Typography component="p" align={matchMd ? "justify" : "left"}>
                Chez Djotta, nous croyons que l&apos;avenir des échanges professionnels est digital, pratique et respectueux de
                l&apos;environnement. C’est pourquoi nous avons créé une solution innovante pour remplacer les cartes de visite
                traditionnelles : les NexGen VCards.
              </Typography>
              <br/>
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                Notre mission
              </Typography>
              <Typography component="p" variant="caption" align={matchMd ? "justify" : "left"}>
                Nous avons pour mission de simplifier les interactions professionnelles grâce à la technologie. Avec une
                NexGen VCard, vous n’avez plus besoin de cartes en papier jetables. Nous vous offrons une carte connectée,
                réutilisable et personnalisable qui permet de partager vos informations professionnelles en un instant.
                Que vous soyez entrepreneur, freelance, ou entreprise, Djotta vous aide à faire une impression durable,
                tout en réduisant votre empreinte écologique.
              </Typography>
              <br/>
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                L&apos;innovation au cœur de notre projet
              </Typography>
              <Typography component="p" variant="caption" align={matchMd ? "justify" : "left"}>
                Nos cartes de visite sans contact utilisent la technologie NFC (Near Field Communication) pour permettre
                un partage rapide et efficace de vos informations. En approchant simplement votre carte Djotta d’un
                téléphone compatible, votre profil numérique se charge instantanément sur l&apos;écran, offrant à votre
                interlocuteur un accès direct à vos coordonnées, votre site web ou même vos réseaux sociaux
                professionnels.
              </Typography>
              <br/>
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                Pourquoi choisir Djotta ?
              </Typography>
              <Typography component="div" variant="caption" align={matchMd ? "justify" : "left"}>
                <ul>
                  <li>
                    <p><strong>Écologique et durable :</strong> Plus besoin de cartes en papier, vos informations sont
                      stockées dans le cloud et peuvent être mises à jour à tout moment.</p>
                  </li>
                  <li>
                    <p><strong>Pratique et moderne :</strong> Partagez vos informations instantanément, sans avoir besoin
                      d&apos;une application ou de connexion internet.</p>
                  </li>
                  <li>
                    <p><strong>Sécurisé :</strong> Vos données sont protégées sur une plateforme sécurisée, et vous avez
                      le contrôle total sur ce que vous partagez.</p>
                  </li>
                  <li>
                    <p><strong>Personnalisable :</strong> Créez une carte qui reflète votre identité professionnelle. Vous
                      pouvez modifier vos informations et l’apparence de votre carte à votre convenance.</p>
                  </li>
                </ul>
              </Typography>
              <br/>
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                Notre engagement
              </Typography>
              <Typography component="p" variant="caption" align={matchMd ? "justify" : "left"}>
                Chez Djotta, nous sommes passionnés par la technologie, mais aussi par l&apos;impact que nous pouvons avoir sur
                l&apos;environnement et la société. En offrant une alternative numérique aux cartes de visite classiques, nous
                contribuons à réduire le gaspillage de papier et à simplifier la gestion de vos contacts professionnels.
              </Typography>
              <br/>
              <Typography variant="h6" gutterBottom align={matchMd ? "justify" : "left"}>
                Rejoignez la révolution des cartes de visite numériques
              </Typography>
              <Typography component="p" variant="caption" align={matchMd ? "justify" : "left"}>
                Optez pour Djotta et découvrez une manière plus moderne, plus rapide et plus écologique de faire des
                rencontres professionnelles.
              </Typography>
              <Typography component="p" variant="caption" align={matchMd ? "justify" : "left"}>
                Nous sommes impatients de vous accompagner dans votre transformation numérique et de vous offrir une
                expérience utilisateur exceptionnelle. Si vous avez des questions ou souhaitez en savoir plus sur nos
                produits, n’hésitez pas à nous contacter !
              </Typography>
            </Paper>
            <FooterWrapper />
          </Grid>
        </Grid>
      </Box>
    </React.Suspense>
  )
}